// Libs
import React from 'react';
import { LoadingButton } from '@mui/lab';

// Components
import Spinner from '../../Spinner';
import { useStyles } from './SkipButtonStyles';

const SkipButton = ({
  onClick = () => {},
  loading = false,
  disabled = false,
  ...props
}) => {
  const { classes } = useStyles();

  return (
    <LoadingButton
      disabled={disabled}
      loading={loading}
      loadingIndicator={<Spinner height="initial" size={14} />}
      onClick={onClick}
      className={classes.button}
      {...props}>
      Skip
    </LoadingButton>
  );
};

export default SkipButton;
